import { useState } from 'react';
import { ToastManagerProp, withToastManager } from 'react-toast-notifications';

import Dialog from 'components/Dialog';
import { Button } from 'components/UtilElements';
import { apiErrorHandler } from 'core/errors';
import { removeExportedActivity, removeExportedAttendance } from 'services/course-api';

type ActivityType = ActivityScore['type'] | 'attendance';

interface Props<T extends { activityId: string; type: ActivityType }> extends ToastManagerProp {
  isOpen: boolean;
  selectedActivity: T | null;
  onExport(): void;
  onClose(): void;
}

const RemoveExportedActivityDialog = <T extends { activityId: string; type: ActivityType }>({
  isOpen,
  onClose: handleClose,
  selectedActivity,
  onExport,
  ...props
}: Props<T>) => {
  const [isRemoving, setIsRemoving] = useState(false);

  const handleRemoveExport = async () => {
    try {
      if (!selectedActivity) return;
      setIsRemoving(true);

      if (selectedActivity.type === 'attendance') {
        await removeExportedAttendance({
          activityId: selectedActivity.activityId,
          activityType: selectedActivity.type,
        });
      } else {
        await removeExportedActivity({
          activityId: selectedActivity.activityId,
          activityType: selectedActivity.type,
        });
      }

      onExport();
    } catch (error: any) {
      apiErrorHandler(props.toastManager, error);
      handleClose();
    } finally {
      setIsRemoving(false);
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title='Remove Exported File'
      footer={
        <>
          <Button
            variant='text'
            color='success'
            size='small'
            onClick={handleClose}
            disabled={isRemoving}
            preventHoverStyles
          >
            No
          </Button>
          <Button
            variant='text'
            color='success'
            size='small'
            onClick={handleRemoveExport}
            disabled={isRemoving}
            preventHoverStyles
          >
            Yes
          </Button>
        </>
      }
    >
      Are you sure you want to remove this column from Gradebook? You will be able to re-export it
    </Dialog>
  );
};
export default withToastManager(RemoveExportedActivityDialog);
